import React, { Component } from "react";

export default class SubscriptionSettings extends Component {
  render() {
    return (
      <div>
        <div className="row m-0 mt-3">
          <div className="container mb-5">
            <div className="row">
              <div className="col-md-4">
                <div className="card card-selector shadow-sm">
                  <div className="card-body text-center">
                    <h4 className="text-primary">Basic</h4>
                    <p>
                      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                      Vero eveniet numquam earum exercitationem consequatur
                      omnis eum, nisi porro beatae quos odio aperiam vel vitae
                      recusandae autem! Aperiam corporis laudantium dolore.
                    </p>
                  </div>
                  <div className="btn btn-dark font-weight-bold">
                    $49 / Month
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card card-selector shadow-sm">
                  <div className="card-body text-center">
                    <h4 className="text-primary">Standard</h4>
                    <p>
                      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                      Vero eveniet numquam earum exercitationem consequatur
                      omnis eum, nisi porro beatae quos odio aperiam vel vitae
                      recusandae autem! Aperiam corporis laudantium dolore.
                    </p>
                  </div>
                  <div className="btn btn-dark font-weight-bold">
                    $99 / Month
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card card-selector shadow-sm">
                  <div className="card-body text-center">
                    <h4 className="text-primary">Premium</h4>
                    <p>
                      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                      Vero eveniet numquam earum exercitationem consequatur
                      omnis eum, nisi porro beatae quos odio aperiam vel vitae
                      recusandae autem! Aperiam corporis laudantium dolore.
                    </p>
                  </div>
                  <div className="btn btn-dark font-weight-bold">
                    $199 / Month
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-3 m-0 border-top">
          <div className="btn btn-primary"> Save</div> or{" "}
          <a className="btn-link">Cancel</a>
        </div>
      </div>
    );
  }
}
